import auth0 from 'auth0-js';
import EventEmitter from 'eventemitter3';
import AUTH_CONFIG from '@/configs/configs.auth0';
import router from './../router';

export default {
  authNotifier: new EventEmitter(),
  auth0: new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid',
  }),
  login() {
    this.auth0.authorize();
  },
  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        router.go('/');
      } else if (err) {
        router.push('/');
      }
    });
  },
  setSession(authResult) {
    const timestamp = new Date().getTime();
    const expiryMilliseconds = authResult.expiresIn * 1000;
    const expiresAt = JSON.stringify(expiryMilliseconds + timestamp);
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    this.authNotifier.emit('authChange', { isAuthenticated: true });
  },
  get isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  },
  get token() {
    return localStorage.getItem('id_token');
  },
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    this.authNotifier.emit('authChange', false);
    router.go('/');
  },
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js